export const FORMULAIRE_REDUCER_NAME = 'formulaires';
export const FORMULAIRE_FORMALITE_SLICE_NAME = 'formulairesFormalites';
